export const DEFAULT_RUN_HISTORY_SIDEBAR_WIDTH = 250;
export const MIN_RUN_HISTORY_SIDEBAR_WIDTH = 200;
export const MAX_RUN_HISTORY_SIDEBAR_WIDTH = 450;
export const MIN_RUN_DETAIL_WIDTH = 320;

export const clampRunHistorySidebarWidth = (width: number, minimum: number, maximum: number) =>
  Math.min(Math.max(width, minimum), maximum);

export const getRunHistorySidebarMaximumWidth = (containerWidth: number) => {
  if (containerWidth <= 0) return MAX_RUN_HISTORY_SIDEBAR_WIDTH;

  return Math.max(
    MIN_RUN_HISTORY_SIDEBAR_WIDTH,
    Math.min(MAX_RUN_HISTORY_SIDEBAR_WIDTH, containerWidth - MIN_RUN_DETAIL_WIDTH),
  );
};
